import { MainReportApiVersion } from 'src/hooks/useMainReportApiVersion';
import { selectConfigurationByKeyword, selectModuleConfiguration } from 'src/store/selectors/configurations';
import { ConfKey } from 'src/interfaces/wtsApiV1';
import { isNil } from 'ramda';
import dayjs from 'dayjs';
import store from 'src/store';
export var PlannerApiVersion;
(function (PlannerApiVersion) {
    PlannerApiVersion[PlannerApiVersion["V1"] = 0] = "V1";
    PlannerApiVersion[PlannerApiVersion["V2"] = 1] = "V2";
})(PlannerApiVersion || (PlannerApiVersion = {}));
// Temporary solution during migration to new main report
// todo remove https://tarkvara.ektaco.ee/issues/32338
export function getPlannerApiVersion() {
    const now = dayjs();
    const mainReportConfig = selectModuleConfiguration(store.getState(), 'MainReport');
    const { StartNewMainReportMonth, ShowOldMainReport } = mainReportConfig;
    const mainReportApiVersion = (() => {
        const newReportMigrationMonth = StartNewMainReportMonth ? dayjs(StartNewMainReportMonth) : null;
        if (!newReportMigrationMonth)
            return MainReportApiVersion.V1;
        return now.isSameOrAfter(newReportMigrationMonth) ? MainReportApiVersion.V2 : MainReportApiVersion.V1;
    })();
    const newReportMigrationMonth = StartNewMainReportMonth ? dayjs(StartNewMainReportMonth) : null;
    const isOldMainReportReadonly = ShowOldMainReport && !!newReportMigrationMonth && now.isAfter(newReportMigrationMonth);
    const showOldConf = selectConfigurationByKeyword(store.getState())(ConfKey.MainReportShowOld);
    const forceShowOldMainReport = !isNil(showOldConf?.KeyValueInt);
    return mainReportApiVersion === MainReportApiVersion.V2 && !isOldMainReportReadonly && !forceShowOldMainReport
        ? PlannerApiVersion.V2
        : PlannerApiVersion.V1;
}
export default function usePlannerApiVersion() {
    const plannerApiVersion = getPlannerApiVersion();
    const isPlannerV1 = plannerApiVersion === PlannerApiVersion.V1;
    const isPlannerV2 = plannerApiVersion === PlannerApiVersion.V2;
    return {
        isPlannerV1,
        isPlannerV2,
        plannerApiVersion
    };
}
